import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eedb9ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-block" }
const _hoisted_2 = { class: "img-block" }
const _hoisted_3 = ["onClick", "src"]
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重新上传看脸原图")
const _hoisted_6 = { class: "text-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20%"} }, "所属项目组：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20%"} }, "电话号码：", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("称呼：")
const _hoisted_10 = { style: {"margin-left":"20px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20%"} }, "年龄：", -1))
const _hoisted_12 = { style: {"margin-left":"20px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20%"} }, "身高：", -1))
const _hoisted_14 = { style: {"margin-left":"20px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20%"} }, "体重：", -1))
const _hoisted_16 = { style: {"margin-left":"20px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20%"} }, "备注：", -1))
const _hoisted_18 = { style: {"margin-left":"20px"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20%"} }, "改善诉求：", -1))
const _hoisted_20 = { style: {"margin-left":"20px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "说明：上传图片会覆盖已有图片！请上传用户原始图片", -1))
const _hoisted_22 = { style: {"text-align":"center"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"100%"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1637045307310",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "5087",
    width: "128",
    height: "128"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M823.424 395.296l-287.52-289.248c-3.2-3.2-6.88-5.536-10.816-7.104C521.056 97.12 516.672 96 512 96c-11.264 0-20.704 6.176-26.4 14.976l-254.4 253.952c-12.512 12.48-12.544 32.736-0.032 45.248 6.24 6.272 14.432 9.376 22.656 9.376 8.16 0 16.352-3.104 22.624-9.344L480 206.976 480 768c0 17.696 14.336 32 32 32s32-14.304 32-32L544 204.96l234.048 235.456c6.24 6.272 14.464 9.44 22.688 9.44 8.16 0 16.32-3.104 22.56-9.312C835.84 428.096 835.904 407.84 823.424 395.296z",
      "p-id": "5088",
      fill: "#bfbfbf"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M896 704c-17.696 0-32 14.304-32 32l0 128L160 864l0-128c0-17.696-14.336-32-32-32s-32 14.304-32 32l0 160c0 17.696 14.336 32 32 32l768 0c17.696 0 32-14.304 32-32l0-160C928 718.304 913.696 704 896 704z",
      "p-id": "5089",
      fill: "#bfbfbf"
    })
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将图片拖到 "),
  /*#__PURE__*/_createElementVNode("em", null, "此处")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "jpg/png 文件不超过5张", -1))
const _hoisted_26 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_spanm = _resolveComponent("spanm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderMsg.faceImgName, (item) => {
          return (_openBlock(), _createElementBlock("div", { key: item }, [
            _createElementVNode("img", {
              onClick: ($event: any) => (_ctx.copyContent(item)),
              src: 
            'https://facemaster.meb.fit/api/face/getOssImage?fileName=' + item
          ,
              class: "img-item"
            }, null, 8, _hoisted_3)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _ctx.reUpload,
            style: {"width":"270px","margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_collapse, {
            modelValue: _ctx.activeNames,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNames) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                title: "基础信息",
                name: "basic"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 2 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createElementVNode("span", null, _toDisplayString(_ctx.orderMsg.groupName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 2 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.orderMsg.phone), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 2 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_spanm, { style: {"margin-left":"20%"} }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.orderMsg.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 2 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.orderMsg.age), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 2 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.orderMsg.height), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 2 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.orderMsg.weight), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 2 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.orderMsg.remark), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                title: "意向信息",
                name: "aim"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 1 }),
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.orderMsg.appeal), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isWorkbench]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isShowDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowDialog) = $event)),
      title: "重新上传图片",
      width: "50%"
    }, {
      default: _withCtx(() => [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_upload, {
            ref: "upload",
            drag: "",
            action: "",
            "auto-upload": false,
            limit: 5,
            multiple: ""
          }, {
            tip: _withCtx(() => [
              _hoisted_25
            ]),
            default: _withCtx(() => [
              _hoisted_23,
              _hoisted_24
            ]),
            _: 1
          }, 512)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.reUploadApi,
            loading: _ctx.uploadLoading
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode(_component_el_button, { onClick: _ctx.closeDialog }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}